/**
 * Classes shared by the filter dialog's two lists (filter fields and column
 * visibility), so the tabs keep matching by construction rather than by
 * copy-paste.
 */

/** Brand-coloured checkbox used by every row in the dialog's lists. */
export const DIALOG_CHECKBOX_CLASS =
  "size-4 rounded data-[state=checked]:bg-brand-primary data-[state=checked]:border-brand-primary";

/** Uppercase heading naming the list below it. */
export const GROUP_HEADING_CLASS =
  "px-3 pt-2.5 pb-1 text-xs font-semibold uppercase tracking-wider text-muted-foreground/70";
